import { render } from "./CurrentOccupancy.vue?vue&type=template&id=6ba53740"
import script from "./CurrentOccupancy.vue?vue&type=script&lang=js"
export * from "./CurrentOccupancy.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__